<template>
  <div class="pdf-test-page">
    <PdfViewer
      v-if="pdfUrl"
      :pdf-url="pdfUrl"
      :show-toolbar="true"
      :initial-scale="1"
      :download-file-name="fileName || 'document.pdf'"
      @loading-progress="onLoadingProgress"
      @pdf-loaded="onPdfLoaded"
    />

 
  </div>
</template>

<script>
import PdfViewer from '@/components/common/PdfViewer.vue'
import { getFileInfo } from '@/api/base/api'

const FILE_ID = '850306267309154304'

export default {
  name: 'PdfTestIndex',
  components: {
    PdfViewer
  },
  data() {
    return {
      loading: false,
      error: '',
      pdfUrl: '',
      fileName: '',
      loadPercent: -1,
      loadSpeed: 0,
      loadRemain: 0,
      loadHint: ''
    }
  },
  mounted() {
    this.loadPdfFile()
  },
  methods: {
    async loadPdfFile() {
      this.loading = true
      this.error = ''
      this.pdfUrl = ''
      this.fileName = ''
      this.loadPercent = -1

      try {
        const res = await getFileInfo(FILE_ID)
        // 接口 data 直接是 URL 字符串
        const url = typeof res === 'string'
          ? res
          : (res && res.data)

        if (!url || typeof url !== 'string' || !url.trim()) {
          this.error = '接口未返回有效的 PDF 地址'
          console.warn('getFileInfo 返回数据：', res)
          return
        }

        this.pdfUrl = url.trim()
        // 从 URL 中提取文件名
        try {
          const params = new URLSearchParams(url.split('?')[1] || '')
          const disposition = decodeURIComponent(params.get('response-content-disposition') || '')
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          this.fileName = match ? match[1].replace(/['"]/g, '') : 'document.pdf'
        } catch (_) {
          this.fileName = 'document.pdf'
        }

        console.log('[PdfTest] PDF 地址已设置:', this.pdfUrl)
      } catch (error) {
        console.error('加载 PDF 文件信息失败：', error)
        this.error = '加载 PDF 文件失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },

    onLoadingProgress({ percent, total, hint, phase }) {
      this.loadPercent = percent
      this.loadSpeed = 0
      this.loadRemain = 0
      this.loadHint = hint || ''
      if (phase === 'fetching' && total > 0) {
        const loaded = Math.round(percent * total / 100)
        this.loadSpeed = 0
        this.loadRemain = 0
      }
    },

    onPdfLoaded({ totalPages, loadTimeSec }) {
      this.loadPercent = -1
      this.loadHint = ''
      console.log(`[PdfTest] PDF 加载完成，共 ${totalPages} 页，耗时 ${loadTimeSec}s`)
    }
  }
}
</script>

<style lang="less" scoped>
.pdf-test-page {
  height: 80vh;
  background: #f5f7fa;
  position: relative;
  background-color: red;
}

.state-wrap {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #606266;
  font-size: 16px;
}

.error-text {
  color: #f56c6c;
}

// 加载进度浮层
.load-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.progress-circle-wrap {
  position: relative;
  width: 160px;
  height: 160px;
}

.progress-circle {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.progress-bg {
  fill: none;
  stroke: #e4e7ed;
  stroke-width: 8;
}

.progress-value {
  fill: none;
  stroke: #409eff;
  stroke-width: 8;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}

.progress-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.progress-pct {
  display: block;
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
}

.progress-hint {
  display: block;
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}

.progress-detail {
  margin-top: 20px;
  font-size: 13px;
  color: #909399;
}
</style>
